import React, { useState, useRef, useEffect } from 'react';
import {Form, Button, Drawer, Table, message} from 'antd';
import { error, openNotification } from 'swfrontend/COMS/NotificationMessageMapping';
import ProgressModal from '../../App/Utils/ProgressModal';
import { DataProvider } from '../DataProvider';
import DPRForm from './components/DPRForm';
import { path } from '../../App/ScreenRouters';

const columns = [
    {
        title: 'Input Date',
        dataIndex: 'input_date',
        key: 'input_date',
    },
    {
        title: 'Planned Value',
        dataIndex: 'planned_value',
        key: 'planned_value',
    },
    {
        title: 'Actual Value',
        dataIndex: 'actual_value',
        key: 'actual_value',
    },
]

const dataProvider = new DataProvider();

const NewDPR = ({ history, isVendorForm=false }) => {
    const formRef = useRef();
    const [form] = Form.useForm();
    const isInEdit = window.location.pathname.split("/").pop() !== 'NewProgress';

    const [showProgress, setShowProgress] = useState(isInEdit);
    const [showEditProgress, setShowEditProgress] = useState(false);
    const [progressData, setProgressData] = useState({});
    const [mstLocation, setMstLocation] = useState([]);
    const [mstProgram, setMstProgram] = useState([]);
    const [mstProject, setMstProject] = useState([]);
    const [mstContractor, setMstContractor] = useState([]);
    const [mstActivity, setMstActivity] = useState([]);
    const [mstUnit, setMstUnit] = useState([]);
    const [mstArea, setMstArea] = useState([]);
    const [mstSubArea, setMstSubArea] = useState([]);
    const [vendorInputs, setVendorInputs] = useState([]);
    const [openDrawer, setOpenDrawer] = useState(false);

    useEffect(() => {
        fetchDropdownValues();
        if (isInEdit) {
            fetchProgressData(window.location.pathname.split("/").pop());
        }
    }, []);

    const masterDataMapping = {
        "MstLocation": setMstLocation,
        "MstProgram": setMstProgram,
        "MstProject": setMstProject,
        "MstSupplier": setMstContractor,
        "MstActivity": setMstActivity,
        "MstUnit": setMstUnit,
        "MstArea": setMstArea,
        "MstSubArea": setMstSubArea
    };

    const fetchDropdownValues = () => {
        ['MstLocation', 'MstProject', 'MstProgram', 'MstSupplier', 'MstActivity', 'MstUnit', 'MstArea', 'MstSubArea'].forEach((model, index) => {
            dataProvider.getDropdownValues(model)
                .then((response) => {
                    if (response.ok) {
                        response.json().then((data) => {
                            const setter = masterDataMapping[model];
                            setter(data.results)
                        })
                    } else {
                        response.json().then((responseJson) => {
                            openNotification("error", "Error", responseJson["message"]);
                        });
                    }
                }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
        })
    }

    const fetchDependentDropdownValues = (model, filter, value, callback) => {
        setShowEditProgress(true);
        dataProvider.getDependentDropdownValues(model, filter + value).then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    const setter = masterDataMapping[model];
                    setter(data.results)
                    callback(value)
                })
            } else {
                response.json().then((responseJson) => {
                    openNotification("error", "Error", responseJson["message"]);
                });
            }
        }).finally(() => setShowEditProgress(false));
    };

    useEffect(() => {
        if(Object.keys(progressData).length > 0) {
            setShowProgress(false);
        }
    }, [progressData]);

    const fetchProgressData = (id) => {

        dataProvider.getProgressData(id)
        .then((res) => {
            if (res.ok) {
                return res.json().then((responseJson) => {
                    setProgressData(responseJson);
                });
            } else if (res.status === 409) {
                return res.json().then((res) => {
                    setShowProgress(false);
                    openNotification('error', res['message']);
                });
            } else {
                return res.json().then((res) => {
                    setShowProgress(false);
                    openNotification('error', 'Error fetching progress data');
                });
            }
        });
    }

    const onFinish = async(values) => {
        // add validations
        for(let i of values['activity_list']) {
            const activity = mstActivity.find(data => data.id == i.activity);
            if (i['previous_month_completion'] > i['scope']) {
                error(`Previous month completion cannot be greater than scope for activity ${activity.activity}`);
                return;
            }

            if (i['monthly_plan'] > i['scope'] - i['previous_month_completion']) {
                error(`Monthly plan cannot be greater than balance scope for activity ${activity.activity}`);
                return;
            }
        }

        setShowEditProgress(true);
        const submitData = isInEdit ? dataProvider.editProgress(values, window.location.pathname.split("/").pop()) : dataProvider.submitProgress(values);
        submitData.then((res) => {
            if (res.ok) {
                return res.json().then((responseJson) => {
                    openNotification("success", "Data submitted successfully");
                    setTimeout(() => {
                        if (isInEdit) {
                            window.location.reload();
                        } else {
                            history.push(`${path}/ViewProgress/` + responseJson['id']);
                        }
                    }, 700);
                });
            } else {
                return res.json().then((res) => {
                    openNotification('error', 'Error submitting progress data');
                });
            }
        }).finally(() => setShowEditProgress(false));
    }

    const onFinishFailed = (values) => {
        formRef.current.scrollToField(values.errorFields[0].name);

        if (values.errorFields.length > 3) {
            openNotification('error', "Please review your form details.");
        } else {
            values.errorFields.forEach((each) => {
                openNotification('error', each.errors[0]);
            });
        }
    }

    const submitVendorInputs = (values) => {
        setShowEditProgress(true);
        dataProvider.sumbitVendorInputs(
            {'actual_for_day': values['actual_for_day'],
             'vendor_input_date': values['input_date'].format('YYYY-MM-DD'),
             'activity': values['vendor_activity']
            },
            window.location.pathname.split("/").pop())
            .then((res) => {
                if (res.ok) {
                    return res.json().then((responseJson) => {
                        openNotification("success", "Data submitted successfully");
                        setTimeout(() => {
                            window.location.reload();
                        }, 700);
                    });
                } else if (res.status === 409) {
                    return res.json().then((res) => {
                        openNotification('error', res['message']);
                    });
                } else {
                    return res.json().then((res) => {
                        openNotification('error', 'Error submitting data');
                    });
                }
            }).finally(() => setShowEditProgress(false));
    }

    const putDecimalLimit = (e) => {
        let input = "" + e;
        if (input.includes(".") && 2) {
            let inputArr = input.split(".");
            if (inputArr[1].length > 2) {
                inputArr[1] = inputArr[1].substr(0, 2);
                e = inputArr.join(".");
                return parseFloat(e)
            }
            return e
        }
        return e
    };

    const setMonthlyPlan = (key) => {
        let activityData = formRef.current.getFieldValue('activity_list');
        // let values = formRef.current.getFieldsValue();
        let week1 = activityData[key]['plan_week_1'] ? activityData[key]['plan_week_1'] : 0;
        let week2 = activityData[key]['plan_week_2'] ? activityData[key]['plan_week_2'] : 0;
        let week3 = activityData[key]['plan_week_3'] ? activityData[key]['plan_week_3'] : 0;
        let week4 = activityData[key]['plan_week_4'] ? activityData[key]['plan_week_4'] : 0;
        let week5 = activityData[key]['plan_week_5'] ? activityData[key]['plan_week_5'] : 0;
        activityData[key]['monthly_plan'] = putDecimalLimit(week1 + week2 + week3 + week4 + week5);
        formRef.current.setFieldsValue({
            activity_list: activityData
        })
    }

    const onChangeActivity = (id, key) => {
        const activity = mstActivity.filter(data => data.id == id);
        let activityData = formRef.current.getFieldValue('activity_list');
        activityData[key]['measurement_unit'] = activity[0]['unit']['unit_id'];
        formRef.current.setFieldsValue({
            activity_list: activityData
        })
    }

    const onChangeContractor = (value) => {        
        formRef.current.setFieldsValue({
            contractor_email: mstContractor.find(data => data.code == value).contact_person_email
        })
    }

    const showVendorInputs = (name) => {
        const vendorInputs = formRef.current.getFieldValue('activity_list')[name]['vendor_inputs'];
        setOpenDrawer(true);
        setVendorInputs(vendorInputs);
    }

    const fetchScope = (key) => {
        setShowEditProgress(true);
        const formValues = formRef.current.getFieldsValue();
        const activityData = formValues['activity_list'];
        const activityDetails = activityData[key];
        const { location, stream, project, area, sub_area } = formValues;
        const { activity, measurement_unit } = activityDetails;

        const queryParams = `location.location_id=${location}&stream.program_id=${stream}&project.project_id=${project}&area.area_id=${area}&sub_area.id=${sub_area}&activity.id=${activity}&unit.unit_id=${measurement_unit}`;

        dataProvider.getDependentDropdownValues('MstScope', queryParams)
            .then((res) => {
                if (res.ok) {
                    return res.json().then((responseJson) => {
                        if (responseJson['results'].length > 0) {
                            message.success("Scope data fetched successfully");
                            activityData[key]['scope'] = responseJson['results'][0]['scope'];
                            activityData[key]['previous_month_completion'] = responseJson['results'][0]['previous_month_completion'];
                            formRef.current.setFieldsValue({
                                activity_list: activityData
                            });
                        } else {
                            message.error("No scope data found for the selected values");
                            activityData[key]['scope'] = 0;
                            activityData[key]['previous_month_completion'] = 0;
                            formRef.current.setFieldsValue({
                                activity_list: activityData
                            });
                        }
                    });
                } else {
                    return res.json().then((res) => {
                        openNotification('error', 'Error fetching scope data');
                    });
                }
            }).finally(() => setShowEditProgress(false));
    }

    return (
        <>
            {showProgress ?
                <ProgressModal showProgress={showProgress} /> :
                <div>
                    <ProgressModal showProgress={showEditProgress} /> 
                    <Form
                        form={form}
                        ref={formRef}
                        name="progress-report"
                        onFinish={isVendorForm ? submitVendorInputs : onFinish}
                        onFinishFailed={onFinishFailed}
                        className="ant-form ant-form-vertical"
                        autoComplete='off'
                        initialValues={progressData}
                    >
                        <Drawer
                            width={"30%"}
                            title="Vendor Inputs"
                            placement="right"
                            open={openDrawer}
                            onClose={() => setOpenDrawer(false)}
                            style={{ marginTop: isVendorForm ? "0px" : "42px" }}
                        >
                            <div className="row form-box">
                                <Table
                                    style={{ width: "100%" }}
                                    columns={columns}
                                    dataSource={vendorInputs}
                                    bordered
                                    pagination={false}
                                    size='small'
                                />
                            </div>
                        </Drawer>
                        <DPRForm 
                            formRef={formRef}
                            activityList={'activity_list' in progressData ? progressData['activity_list']: []}
                            activityMonth={isInEdit ? progressData['activity_month']: null}
                            createdDate={progressData['created_date']}
                            isInEdit={isInEdit}
                            vendorInputsSubmitted={'actual_day' in progressData}
                            isVendorForm={isVendorForm}
                            disabled={isVendorForm ? true : false}
                            location={mstLocation}
                            program={mstProgram}
                            project={mstProject}
                            contractor={mstContractor}
                            activity={mstActivity}
                            unit={mstUnit}
                            area={mstArea}
                            subArea={mstSubArea}
                            setMstArea={setMstArea}
                            setMstSubArea={setMstSubArea}
                            fetchScope={fetchScope}
                            showVendorInputs={showVendorInputs}
                            setMstProgram={setMstProgram}
                            setMonthlyPlan={setMonthlyPlan}
                            putDecimalLimit={putDecimalLimit}
                            onChangeActivity={onChangeActivity}
                            onChangeContractor={onChangeContractor}
                            fetchDependentDropdownValues={fetchDependentDropdownValues}
                        />

                        <div style={{ display: "flex", justifyContent: "right", marginRight: "15px" }}>
                            {/* {
                                isInEdit && 'vendor_inputs' in progressData && progressData['vendor_inputs'].length > 0 &&
                                <Button style={{ marginRight: "15px" }}
                                    onClick={() => setOpenDrawer(true)}
                                    type="primary">{"Vendor Inputs"}
                                </Button>
                            } */}
                            {
                                !isVendorForm &&
                                <Button
                                    htmlType="submit"
                                    type="primary">{isInEdit ? "Update" : "Submit"}
                                </Button>
                            }
                        </div>
                    </Form>
                </div>
            }
        </>
    )
}

export default NewDPR;
